var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-area"},[_c('vertical-list-slider',{attrs:{"listItems":_vm.buttonList,"componentStyle":_vm.componentStyle,"isActiveVue":_vm.isActiveVue}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }